import { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { loginUser } from "../../utils/wellspoken.api";
import { changePassword } from "../../utils/wellspoken.api";
import toast from "react-hot-toast";

const Profile = () => {
  const { user } = useAuth();

  const [view, setView] = useState("profile"); // profile | password
  const [loading, setLoading] = useState(false);

  const [userData, setUserData] = useState({
    name: "",
    email: "",
    mobile: "",
  });
  const [passwordData, setPasswordData] = useState({
    ToEmail: "",
    OldPassword: "",
    NewPassword: "",
    ConfirmPassword: "",
  });

  /* Prefill profile */
  useEffect(() => {
    if (!user) return;

    setUserData({
      name: user.user.name ?? "",
      email: user.user.email ?? "",
      mobile: user.user.mobile ?? "",
    });

    setPasswordData((prev) => ({
      ...prev,
      ToEmail: user.user.email,
    }));
  }, [user]);

  if (!user) {
    return <p className="text-center">Loading profile…</p>;
  }

  /* Handlers */
  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((prev) => ({ ...prev, [name]: value }));
  };

  const handleProfileSubmit = (e) => {
    e.preventDefault();

    loginUser({
      ...user,
      name: userData.name,
      email: userData.email,
      phone: userData.mobile,
    });
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await changePassword(passwordData);
      toast.success("Password changed successfully");
      setView("profile");
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main
      className="min-h-screen w-full
             bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50
             px-4 sm:px-6 lg:px-10 "
    >
      {/* Header */}
      <section
        className="w-full text-center mb-8"
        aria-labelledby="profile-heading"
      >
        <h1
          id="profile-heading"
          className="text-3xl sm:text-4xl font-bold text-gray-900"
        >
          My Profile
        </h1>
        <p className="mt-2 text-gray-600 max-w-2xl mx-auto">
          Manage your personal information securely.
        </p>
      </section>

      {/* Card – FULL WIDTH */}
      <section
        className="w-full
               bg-white/95 backdrop-blur-xl
               rounded-2xl shadow-lg
               p-6 sm:p-8 lg:p-10"
        aria-label="Profile form section"
      >
        {/* PROFILE FORM */}
        {view === "profile" && (
          <form
            onSubmit={handleProfileSubmit}
            className="space-y-6"
            aria-label="Update profile form"
          >
            {/* Name */}
            <div>
              <label
                htmlFor="name"
                className="block text-sm font-medium text-gray-700"
              >
                Full Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={userData.name}
                readOnly
                onChange={handleProfileChange}
                required
                 className="mt-2 w-full rounded-lg border border-gray-300
                       bg-gray-100 px-4 py-2.5 text-gray-700
                       cursor-not-allowed"
              />
            </div>

            {/* Email */}
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                Email Address
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={userData.email}
                readOnly
                required
                className="mt-2 w-full rounded-lg border border-gray-300
                       bg-gray-100 px-4 py-2.5 text-gray-700
                       cursor-not-allowed"
              />
            </div>

            {/* Mobile */}
            <div>
              <label
                htmlFor="mobile"
                className="block text-sm font-medium text-gray-700"
              >
                Mobile Number
              </label>
              <input
                type="tel"
                id="mobile"
                name="mobile"
                value={userData.mobile}
                readOnly
                onChange={handleProfileChange}
                required
                className="mt-2 w-full rounded-lg border border-gray-300
                       bg-gray-100 px-4 py-2.5 text-gray-700
                       cursor-not-allowed"
              />
            </div>

            {/* Actions */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <button
                type="button"
                onClick={() => setView("password")}
                className="w-full sm:w-auto rounded-xl
                       border border-blue-500 px-6 py-3
                       text-blue-600 font-semibold
                       hover:bg-blue-50
                       focus-visible:outline-none
                       focus-visible:ring-2 focus-visible:ring-blue-500/40
                       transition"
              >
                Change Password
              </button>
            </div>
          </form>
        )}

        {/* PASSWORD FORM */}
        {view === "password" && (
          <form
            onSubmit={handlePasswordSubmit}
            className="space-y-6"
            aria-label="Change password form"
          >
            {[
              { id: "oldPassword", label: "Current Password", name: "OldPassword" },
              { id: "newPassword", label: "New Password", name: "NewPassword" },
              { id: "confirmPassword", label: "Confirm New Password", name: "ConfirmPassword" },
            ].map((field) => (
              <div key={field.id}>
                <label
                  htmlFor={field.id}
                  className="block text-sm font-medium text-gray-700"
                >
                  {field.label}
                </label>
                <input
                  type="password"
                  id={field.id}
                  name={field.name}
                  required
                  onChange={handlePasswordChange}
                  className="mt-2 w-full rounded-lg border border-gray-300
                         bg-white px-4 py-2.5 text-gray-900
                         transition
                         focus:border-blue-500
                         focus:ring-2 focus:ring-blue-500/30"
                />
              </div>
            ))}

            {/* Actions */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <button
                type="submit"
                disabled={loading}
                className="w-full sm:w-auto rounded-xl
                       bg-gradient-to-r from-blue-600 to-indigo-600
                       px-6 py-3 text-white font-semibold
                       hover:from-blue-500 hover:to-indigo-500
                       focus-visible:outline-none
                       focus-visible:ring-2 focus-visible:ring-blue-500/40
                       disabled:opacity-60 transition"
              >
                {loading ? "Updating..." : "Update Password"}
              </button>

              <button
                type="button"
                onClick={() => setView("profile")}
                className="w-full sm:w-auto rounded-xl
                       border border-gray-300 px-6 py-3
                       text-gray-700 font-semibold
                       hover:bg-gray-100
                       focus-visible:outline-none
                       focus-visible:ring-2 focus-visible:ring-blue-500/40
                       transition"
              >
                Cancel
              </button>
            </div>
          </form>
        )}
      </section>
    </main>

  );
};

export default Profile;
